import { useSelector } from "react-redux";

function List({ list, editHandler }) {

    const stateTicket = useSelector((state) => state.ticket);

    return (
        <>
            {list.map((item) => (
                <div key={item.ID_Ticket} className="list_item mt-15" onClick={() => { editHandler(item) }}>
                    <div className="">
                        <div className='title' >
                            {item.Name}
                            {stateTicket.unreadList.filter(a => a.Count_Message > 0).length > 0 && (<span className="badge badge-menu badge-dot warning ml-5"> </span>)}

                        </div>
                        <div className="subtitle">{item.Date_Add}</div>
                    </div>
                </div>
            ))}
        </>)
}

export default List;